module.exports = __webpack_public_path__ + "img/advantages-bg.8a93fae4.png";